import { Component, OnInit, EventEmitter, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { UntypedFormGroup, FormControl, Validators, UntypedFormControl } from '@angular/forms';

import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { stateOptionsSample, DatePickerGlobalOptions, serviceConstants } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { CommonService } from 'src/app/services/common.service';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import { DatePipe } from '@angular/common';
import * as $ from 'jquery';
import { UserService } from "src/app/services/user.service";
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Document_Upload_File } from 'src/app/models/common';


@Component({
  selector: 'app-grants-budget-view-budget-request',
  templateUrl: './grants-budget-view-budget-request.component.html',
  styleUrls: ['./grants-budget-view-budget-request.component.scss']
})
export class GrantsBudgetViewBudgetRequestComponent implements OnInit {

  @Input() public Content: any;
  appid: string = "";
  formFields;
  expStaticFields:any;
  stateOptions = stateOptionsSample;
  totalfee: any;
  requestamount: any;
  allocationamount: any;
  allocationdate: any;
  notes: string;
  typevalue: string;
  subtypevalue: string;
  BudgetForm: UntypedFormGroup;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  grantcurrencycode: any = "";
  granttype: number;
  expenditureamount: number;
  balanceamount: number;
  StatusStr: any;
  staticformFields : any;
  minDate : Date;
  expAmount: any;   
  ReconId: string;
  uploadedFiles:Document_Upload_File[]
  maxDate: Date = new Date();
  disabledPresentDate = [
    new Date()
  ];
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;

  constructor(
    private summaryService: GrantsSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalService: NgbModal,
    public datepipe: DatePipe,
    private userService: UserService,
    private commonService: CommonService
  ) {

  }

  
  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode,this.appid)
      .subscribe(summary => {
        if(screenCode == 'SCR-026'){
        this.staticformFields = summary["Data"]; }
    else{
          this.expStaticFields = summary["Data"]; 
          if(this.granttype == 3)
          this.expStaticFields.RECONCILIATION_UPLOAD.IS_MANDATORY = false;
        }
      });
  }

  ngOnInit() {
     this.minDate = new Date ; 
    const grantapp = this.commonService.getGrantsApp();// "8b3a39fb-99ee-44ce-8c03-c5417eb040d2";
    this.granttype = grantapp.GRANT_TYPE;
    this.appid = grantapp?.ID;
    this.getStaticFiledsData('SCR-026');
    this.getStaticFiledsData('SCR-030');
    this.expAmount = this.Content.content.record.EXPENDITURE_AMOUNT == 0? null : this.Content.content.record.EXPENDITURE_AMOUNT;
    this.heading = this.Content.heading;    

    
    // if (this.granttype == 1)
    //   this.grantcurrencycode = this.userService.getGrantCMECurrencySymbol();
    // else if (this.granttype == 2)
    //   this.grantcurrencycode = this.userService.getGrantSponsorCurrencySymbol();
    // else if (this.granttype == 3)
    //   this.grantcurrencycode = this.userService.getGrantCharitableCurrencySymbol();

    // if (this.grantcurrencycode == null || this.grantcurrencycode == undefined || this.grantcurrencycode == "")
    //   this.grantcurrencycode = "$";


    this.BudgetForm = new UntypedFormGroup({
      ID: new UntypedFormControl(null),
      APPLICATION_ID: new UntypedFormControl(null),
      BUGET_TYPE_ID: new UntypedFormControl("", [Validators.required]),
      BUDGET_SUB_TYPE_ID: new UntypedFormControl("", [Validators.required]),
      NOTES: new UntypedFormControl("", [Validators.required]),
      REQUESTED_AMOUNT: new UntypedFormControl("", [Validators.required]),
      TOTAL_FEE: new UntypedFormControl("", [Validators.required]),
      ALLOCATION_AMOUNT: new UntypedFormControl("", [Validators.required]),
      ALLOCATION_DATE: new UntypedFormControl("", [Validators.required]),
      ALLOCATION_NOTES: new UntypedFormControl("", [Validators.required]),
      EXPENDITURE_AMOUNT: new UntypedFormControl("", [Validators.required]),
      BALANCE_AMOUNT: new UntypedFormControl(""),
    });

    this.GetEditData();
  }
  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }
  OpenFile(item: Document_Upload_File): void {
    
    if (item.Status == "Edit") {
      let Url = serviceConstants.apiURL + "api/screen/downloadfile/" + item.ID;
      window.open(Url);
    }
  }

  GetEditData(): void {
    this.summaryService.getBudget(this.Content.content.id,this.appid).subscribe(summary => {
      this.BudgetForm.patchValue({
        ID: summary["ID"],
        APPLICATION_ID: summary["APPLICATION_ID"],
        BUGET_TYPE_ID: summary["BUGET_TYPE_ID_Str"],
        BUDGET_SUB_TYPE_ID: summary["BUDGET_SUB_TYPE_ID_Str"],
        TOTAL_FEE: summary["TOTAL_FEE"],
        REQUESTED_AMOUNT: summary["REQUESTED_AMOUNT"],
        NOTES: summary["NOTES"],
        ALLOCATION_AMOUNT: summary["ALLOCATION_AMOUNT"],
        ALLOCATION_DATE: summary["ALLOCATION_DATE"],
        ALLOCATION_NOTES: summary["ALLOCATION_NOTES"],
        EXPENDITURE_AMOUNT: summary["EXPENDITURE_AMOUNT"]
      });
      
      this.ReconId = summary["ReconciliationId"];
      this.expenditureamount = summary["EXPENDITURE_AMOUNT"];
      this.allocationamount = summary["ALLOCATION_AMOUNT"];

      if (summary["ALLOCATION_DATE"] != null && summary["ALLOCATION_DATE"] != "") {
        let formd2 = this.commonService.getdisplayedDate(this.BudgetForm.controls["ALLOCATION_DATE"].value);

        this.BudgetForm.controls["ALLOCATION_DATE"].setValue(formd2);
        if(formd2 < new Date)
          {
            this.minDate = formd2;
          }
      }
      this.uploadedFiles = summary.uploadFiles;
      if (summary["STATUS"] > 1) {
        this.grantcurrencycode = summary["CURRENCY_SYMBOL"];
      }

      this.balanceamount = this.allocationamount - this.expenditureamount;
      this.StatusStr = summary["StatuStr"];


      this.BudgetForm.controls["BALANCE_AMOUNT"].setValue(this.balanceamount == 0 ? null : this.balanceamount);
      this.BudgetForm.controls["EXPENDITURE_AMOUNT"].setValue(this.expenditureamount == 0 ? null : this.expenditureamount);

      if (this.extendedForm != null && this.extendedForm != undefined) {
        this.extendedForm.rowid = summary["ID"];
        this.extendedForm.getResponse();
      }

      if (this.heading == "View") {
        this.BudgetForm.disable();
        if(this.Content.content.screen == "Budget"){          
          this.BudgetForm.controls["EXPENDITURE_AMOUNT"].enable();
        }
      }  
      
      if(this.grantcurrencycode==null || this.grantcurrencycode==undefined || this.grantcurrencycode=="")
      {
        this.getLatestSymbol()
      }

    });


  }

  getLatestSymbol()
  {
    if (this.granttype == 1)
    {
      this.userService.getGrantCMECurrencySymbol(this.appid).subscribe(x=>{
        this.grantcurrencycode=x["Data"];
        if (this.grantcurrencycode == null || this.grantcurrencycode == undefined || this.grantcurrencycode == "")
         this.grantcurrencycode = "$";
      });
    }
    else if (this.granttype == 2)
    {
      this.userService.getGrantSponsorCurrencySymbol(this.appid).subscribe(x=>{
        this.grantcurrencycode=x["Data"];
        if (this.grantcurrencycode == null || this.grantcurrencycode == undefined || this.grantcurrencycode == "")
         this.grantcurrencycode = "$";
      });
    }
    else if (this.granttype == 3)
    {
      this.userService.getGrantCharitableCurrencySymbol(this.appid).subscribe(x=>{
        this.grantcurrencycode=x["Data"];
        if (this.grantcurrencycode == null || this.grantcurrencycode == undefined || this.grantcurrencycode == "")
         this.grantcurrencycode = "$";
      });
    }
  }
  uploadchange(event): void {
    if (this.uploadedFiles == undefined || this.uploadedFiles == null) {
      this.uploadedFiles = [];
    }

    let hasUnFormat = false;
    let hasMultipleFiles = false;
    let Duplicate_File_List = [];

    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      var file = event.target.files[i].name;
      var ext = file.match(/\.([^\.]+)$/)[1];
      var filesize = event.target.files[i].size;

      if (file != null && ((filesize > 15728640) || (ext != 'docx' && ext != 'doc' && ext != 'ppt' && ext != 'pptx' && ext != 'xls' && ext != 'xlsx' && ext != 'txt' && ext != 'pdf'))) {
        hasUnFormat = true;
      }
      else {
        let hasValue;

        uploadFile.ID = this.commonService.getUniqueId();
        uploadFile.DOCUMENT_NAME = event.target.files[i].name;
        uploadFile.File = event.target.files[i];
        uploadFile.Status = "Add";
        if (this.uploadedFiles?.length > 0) {
          hasValue = this.uploadedFiles?.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());
        }

        if (hasValue?.length > 0) {
          hasMultipleFiles = true;
          Duplicate_File_List.push(uploadFile.DOCUMENT_NAME);
        } else {

          if(this.expStaticFields?.RECONCILIATION_UPLOAD.IS_MULTISELECT){
            this.uploadedFiles.push(uploadFile);
          } else{
            this.uploadedFiles = [];
            this.uploadedFiles.push(uploadFile);
          }
        }
      }
    }

    if (hasUnFormat) {
      this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 15MB");
    }
    
    if(hasMultipleFiles){
      this.commonService.ValidationBanner("File already exists with " + Duplicate_File_List.join(', ') + ". Please update the unique file name");
    }
  }

  DeleteUpload(file): void {
    
    let code = file.ID;
    if (file.Status == "Add") {
      this.uploadedFiles = this.uploadedFiles.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      this.commonService.CheckIsFileIsRefereancedInReviw(code).subscribe((x)=>{
        if(x["Status"]==2 && x["Data"]==false)
        {
          this.commonService.ValidationBanner(x["Message"]);
        }
        else{
          file.Status = "Delete";
          let index = this.uploadedFiles.findIndex(x => x.ID == file.ID);
          this.uploadedFiles.splice(index, 1);
        }
      });
    }
  }

  SaveReconsiliation() {
    if (this.validateControls()) {
      let formData = this.BudgetForm.value;

      formData["ID"] = this.ReconId;
      formData["APPLICATION_ID"] = this.appid;     
      formData["EXPENDITURE_AMOUNT"] = parseInt(formData["EXPENDITURE_AMOUNT"]);
      formData["uploadFiles"] = this.uploadedFiles;
      formData["SCREEN_NAME"] = this.Content.content.screen;
      formData["BUDGET_REQUEST_ID"] = this.Content.content.id;

      let uploadData = new FormData();
      for (let i = 0; i < this.uploadedFiles.length; i++) {
        if (this.uploadedFiles[i].Status == "Add") {
          uploadData.append(this.uploadedFiles[i].ID, this.uploadedFiles[i].File);
          this.uploadedFiles[i].File = null;
        }
      }

      uploadData.append("reconciliation", JSON.stringify(formData));
      if (this.heading == "Add") {
        this.summaryService.Upload('api/gmconciliation/insertreconciliation', uploadData).subscribe(summary => {
          if (summary.Status == 0)
          {
          this.extendedForm.saveControls(summary.TransactionID, this.appid, summary.TransactionCode).subscribe(result1 => {
            if (result1.Status == 0) {
              this.commonService.SuccessBanner('Data has been saved successfully');
              this.modalRef.close();
            }
            else
            {
              this.commonService.ValidationBanner(result1.Message);
            }
          });
          }
          else
          {
            this.commonService.ValidationBanner(summary.Message);
          }
        });
      }
      else {
        this.summaryService.Upload('api/gmconciliation/updatereconciliation', uploadData).subscribe(summary => {
          if (summary.Status === 0 ||summary.ErrorCode=="NOCHANGES")
          {
            this.extendedForm.saveControls(summary.TransactionID, this.appid, summary.TransactionCode).subscribe(result1 => {
              if(result1.ErrorCode === "NOCONTROLS")
              {
                if (summary.Status == 0) {
                  this.commonService.SuccessBanner('Budget expenditure details updated successfully');
                  this.modalRef.close('yes');
                } else {
                  this.commonService.ValidationBanner(summary.Message);
                }
              }
              else
              {
                if (summary.ErrorCode === "NOCHANGES" && result1.ErrorCode === "NOCHANGES") {
                  this.commonService.ValidationBanner(summary.Message);
                }
                else {
                  this.commonService.SuccessBanner('Budget expenditure details updated successfully');
                  this.modalRef.close('yes');
                }
              }
            });
          }
          else{
            this.commonService.ValidationBanner(summary.Message);
          }
        });
      }
    }
  }

  validateControls() {
    
    var formDate = this.BudgetForm.value;
    formDate["ALLOCATION_AMOUNT"] = this.BudgetForm.controls['ALLOCATION_AMOUNT'].value;

    var message = "";
    var isValid = true;
    if(this.expStaticFields?.EXPENDITURE_AMOUNT.IS_Display && this.expStaticFields?.EXPENDITURE_AMOUNT.IS_MANDATORY){
      if (formDate.EXPENDITURE_AMOUNT === null || formDate.EXPENDITURE_AMOUNT === "" || formDate.EXPENDITURE_AMOUNT === undefined || parseInt(formDate["EXPENDITURE_AMOUNT"]) == 0) {
        $("#EXPENDITURE_AMOUNT").addClass("ng-touched ng-invalid validate-error");
        $("#EXPENDITURE_AMOUNT").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.expStaticFields?.EXPENDITURE_AMOUNT.LABEL_NAME} <br/>`;
        isValid = false;
        //return false;
      } else {
        $("#EXPENDITURE_AMOUNT").addClass("ng-untouched ng-valid");
        $("#EXPENDITURE_AMOUNT").removeClass("ng-touched ng-invalid validate-error");
      }
    }   

    if (this.expStaticFields?.RECONCILIATION_UPLOAD.IS_Display && this.expStaticFields?.RECONCILIATION_UPLOAD.IS_MANDATORY) {
      if (this.uploadedFiles.length ==0) {
        $("#RECONCILIATION_UPLOAD").addClass("ng-touched ng-invalid validate-error");
        $("#RECONCILIATION_UPLOAD").removeClass("ng-untouched ng-valid");
        message += `Please upload ${this.expStaticFields?.RECONCILIATION_UPLOAD.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#RECONCILIATION_UPLOAD").addClass("ng-untouched ng-valid");
        $("#RECONCILIATION_UPLOAD").removeClass("ng-touched ng-invalid validate-error");
      }
    }
    
    if (formDate["EXPENDITURE_AMOUNT"] != null && parseInt(formDate["EXPENDITURE_AMOUNT"]) > parseInt(formDate["ALLOCATION_AMOUNT"]) ) {
      $("#EXPENDITURE_AMOUNT").addClass("ng-touched ng-invalid validate-error");
      $("#EXPENDITURE_AMOUNT").removeClass("ng-untouched ng-valid");
      message += "The expenditure amount cannot be greater than the allocated amount<br/>";
      isValid = false;
    } else {
      $("#EXPENDITURE_AMOUNT").addClass("ng-untouched ng-valid");
      $("#EXPENDITURE_AMOUNT").removeClass("ng-touched ng-invalid validate-error");
    }

    if (!isValid) {
      this.commonService.ValidationBanner(message);
      return isValid;
    }
    return isValid;
  }
}
